export const DEV_MODE = import.meta.env.VITE_APP_MODE === 'development'
